export default function formatStatusString(value: 'processing' | 'active' | 'inactive') {
    switch(value) {
        case 'processing':
            return 'Processando';
        case 'active':
            return 'Ativo';
        case 'inactive':
            return 'Inativo';
    }
}